<template>
  <div id="bodie">
    <h4><span v-if="selectBook">{{selectBook.title}} > </span>本文の編集<span v-if="selectBody"> > {{selectBody.title}}</span></h4>

    <el-form :model="body" ref="bodyForm" status-icon>
      <el-form-item prop="title" label="タイトル" :rules="[{ required: true, message: 'タイトルを入力してください', trigger: 'blur' }]">
        <el-input placeholder="タイトル" v-model="body.title"></el-input>
      </el-form-item>

      <label class="el-form-item__label" style="float:unset;">本文</label>
      <el-form-item>
        <editor v-model="body.code" :init="editorConfig"></editor>
      </el-form-item>

      <el-form-item label="章の設定">
        <el-select v-model="selectChapter" value-key="id">
          <el-option
            :key="0"
            :label="'指定しない'"
            :value="{id:0, title:'指定しない'}">
          </el-option>
          <el-option
            v-for="chapter in $store.state.Chapters.chapters"
            :key="chapter.id"
            :label="chapter.title"
            :value="chapter">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button :disabled="!isEdit" size="medium" type="primary" @click="save('bookForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Editor from '@tinymce/tinymce-vue'
export default {
  name: 'bodie',
  components: {
    'editor': Editor
  },
  data () {
    return {
      editorConfig: {},
      body: {
      },
      selectChapter: {
        id: 0,
        title: '指定しない'
      }
    }
  },
  created () {
    console.log('body::created')
    console.log(this.$route.params.body_id)

    this.editorConfig = this.cloneObject(this.Constants.EDITOR_CONFIG)
    this.editorConfig.file_picker_callback = this.Constants.EDITOR_CONFIG_FILEPICKER_CALLBACK

    this.fetchChapters()

    var self = this
    this.$store.dispatch('Bodies/get', {'id': this.$route.params.body_id}).then(function (response) {
      self.body = self.cloneObject(self.selectBody)
      self.selectChapter = self.getChapter(self.body.chapter_id)
    })
  },
  destroyed () {
    console.log('body::destroyed')
    this.$store.dispatch('Bodies/clear')
  },
  computed: {
    ...mapGetters('Books', ['selectBook']),
    ...mapGetters('Bodies', ['selectBody']),
    ...mapGetters('Chapters', ['getChapter']),
    isEdit () {
      console.log(this.body.chapter_id + ':' + this.selectChapter.id)
      return !this.equalObject(this.body, this.selectBody) || this.body.chapter_id !== this.selectChapter.id
    }
  },
  methods: {
    fetchChapters () {
      this.$store.dispatch('Chapters/fetch', {'book_id': this.$route.params.id})
    },
    save () {
      if (this.body.title === '') {
        this.errorMessage('タイトルが入力されていません')
        return
      }

      var body = {
        id: this.$route.params.body_id,
        chapter_id: this.selectChapter.id,
        title: this.body.title,
        code: this.body.code
      }

      var self = this
      this.$store.dispatch('Bodies/updateDetail', {'body': body}).then(function (response) {
        if (!response.result) {
          self.errorMessage(response.message)
        } else {
          self.successMessage(response.message)
          self.body = self.cloneObject(self.selectBody)
          self.selectChapter = self.getChapter(self.body.chapter_id)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/04-pages/Bodie.vue